export const QualityReport = ({ props }) => ([
  { text: 'Ja', value: '::true' },
  { text: 'Nein', value: '::false' },
])
